var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 45,
    viewBox: "0 0 24 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 25.541L12 33.6973L24 25.541L12 45L0 25.541ZM6.61274 32.4539L12 41.1897L17.3873 32.4539L12 36.1155L6.61274 32.4539ZM21.394 22.2702L11.9994 4.31328L2.59877 22.27L11.9996 28.6596L21.394 22.2702ZM12 31.0781L23.9921 22.9219L12 0L0 22.9219L12 31.0781Z",
    fill: "#A440F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 34.9064L3.30637 28.9974L12 43.0949L20.6936 28.9974L12 34.9064ZM24 25.541L12 45L0 25.541L12 33.6973L24 25.541ZM22.693 22.596L11.9997 2.15664L1.29939 22.5959L11.9998 29.8689L22.693 22.596ZM12 31.0781L23.9921 22.9219L12 0L0 22.9219L12 31.0781Z",
    fill: "#EFB0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeth);
export default __webpack_public_path__ + "static/media/weth.74448e62c2ed7fb832818da29009a5ed.svg";
export { ForwardRef as ReactComponent };